import React, { Component } from "react";
import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import Router from "./Routes/router";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

class App extends Component {
  componentWillMount() {
    var config = {
      apiKey: "AIzaSyCGRc-QqaPUxOkovvJ_zTca7GTvDPWWi08",
      authDomain: "mvp-jkj.firebaseapp.com",
      databaseURL: "https://mvp-jkj.firebaseio.com",
      projectId: "mvp-jkj",
      storageBucket: "mvp-jkj.appspot.com",
      messagingSenderId: "684509652901"
    };
    firebase.initializeApp(config);
  }
  render() {
    return (
      <div className="App">
        <Navbar />
        {/* <Next /> */}
        <Router />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js